import { render, staticRenderFns } from "./areaListTree.vue?vue&type=template&id=0b6d7508&scoped=true&"
import script from "./areaListTree.vue?vue&type=script&lang=js&"
export * from "./areaListTree.vue?vue&type=script&lang=js&"
import style0 from "./areaListTree.vue?vue&type=style&index=0&id=0b6d7508&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6d7508",
  null
  
)

export default component.exports